export default __webpack_public_path__ + "static/business-profile-6c7639547e184baa150ff304a25721d8.webp";